
    /* Anchor links */
    jQuery('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            || location.hostname == this.hostname) {

            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                jQuery('html,body').animate({
                    scrollTop: target.offset().top - 100
                }, 500);
                return false;
            }
        }
    });

    /* Open & close modal */
    jQuery('.header .page-navigation .page-navigation__main > li:nth-child(1), .header .page-navigation .page-navigation__main > li:nth-child(2)').hover(function() {
        jQuery('body').addClass('has-dark-overlay');
    },function(){
        jQuery('body').removeClass('has-dark-overlay');
    });

    /* Accordeon tabs */
    jQuery('.accordeon__title').on('click', function () {
        var parent = jQuery(this).parent();
        var answer = jQuery(parent).find('.accordeon__content');

        jQuery(this).toggleClass('accordeon__title--active');
        jQuery(parent).toggleClass('accordeon__wrapper--active');
        jQuery(answer).slideToggle('medium');
    });

    /* Sidebar toggle (single-ondersteuning) */
    jQuery('.sidebar--ondersteuning .sidebar__title').on('click', function () {
        var parent = jQuery(this).parent();
        var menu = jQuery(parent).find('ul');

        if(!jQuery(parent).hasClass('sidebar__item--current')) {
            jQuery(this).toggleClass('sidebar__title--active');
            jQuery(parent).toggleClass('sidebar__item--active');
            jQuery(menu).slideToggle('medium');
        }
    });

    /* Sidebar open -- mobile (single-ondersteuning) */
    jQuery('.sidebar--ondersteuning .sidebar__main-title').on('click', function () {
        var parent = jQuery(this).parent();
        var sidebarWrapper = jQuery(parent).find('.sidebar__wrapper');

        jQuery('body').addClass('sidebar-overlay');
        jQuery(this).addClass('sidebar__main-title--active');
        jQuery(sidebarWrapper).addClass('sidebar__wrapper--active');
    });

    /* Sidebar open -- mobile (single-ondersteuning) */
    jQuery('.sidebar--ondersteuning .sidebar__wrapper-close').on('click', function () {
        jQuery('body').removeClass('sidebar-overlay');
        jQuery('.sidebar__main-title--active').removeClass('sidebar__main-title--active');
        jQuery('.sidebar__wrapper--active').removeClass('sidebar__wrapper--active');
    });


    /* Keep position after filling out search form on page 'Ondersteuning' */
    // Add current offset position to storage on form submit
    jQuery('#ondersteuning-form').submit(function() {
        var yOffset = window.pageYOffset;
        localStorage.setItem('yOffset', yOffset);
    });

    // Get stored offset position
    var getYoffset = localStorage.getItem('yOffset');
    getYoffset = parseInt(getYoffset);

    // Get current url and (if necessary) strip from query
    var getCurUrl = window.location.href;
    getCurUrl = getCurUrl.replace(/\?.*/,'');

    // Check if current URL contains 'ondersteuning'
    if (getCurUrl.includes('ondersteuning')) {

        // Check if offset position is stored
        if(getYoffset) {
            jQuery(window).scrollTop(getYoffset);

            // Reset offset position
            localStorage.removeItem('yOffset');
        }
    }

    /* Append header__top to header__bottom on mobile */
    if (jQuery(window).width() < 992) {
        var headerSearch = jQuery('.top-bar .search-form-navigation');
        var headerTopNavigation = jQuery('.top-bar .top-bar__navigation');

        var headerBottom = jQuery('.header__bottom .col-lg-12');
        var headerBottomNavigation = jQuery('.header__bottom .page-navigation');

        jQuery(headerBottom).append(headerSearch);
        jQuery(headerBottomNavigation).append(headerTopNavigation);
    }

    /* Toggle account sidebar on mobile */
    if (jQuery(window).width() < 1200) {
        jQuery('.sidebar--account .sidebar__title').on('click', function(){
            var parent = jQuery(this).parent();
            var sidebarList = jQuery(parent).find('ul');

            jQuery(sidebarList).slideToggle('medium');
        });
    }

    /* Open/close search function on mobile */
    jQuery('.search-toggle').on('click', function(){
        jQuery('.search-form-navigation').addClass('search-form-navigation--active');
    });

    jQuery('.search-form-navigation__close').on('click', function(){
        jQuery('.search-form-navigation').removeClass('search-form-navigation--active');
    });

    /* Open navigation */
    jQuery('.mobile-toggle__open').on('click', function(){
        var mobileToggleClose = jQuery(this).parent().find('.mobile-toggle__close');

        jQuery(this).addClass('mobile-toggle__open--active');
        jQuery(mobileToggleClose).addClass('mobile-toggle__close--active');

        jQuery('.page-navigation').addClass('page-navigation--active');
    });

    /* Close navigation */
    jQuery('.mobile-toggle__close').on('click', function(){
        var mobileToggleOpen = jQuery(this).parent().find('.mobile-toggle__open');

        jQuery(this).removeClass('mobile-toggle__close--active');
        jQuery(mobileToggleOpen).removeClass('mobile-toggle__open--active');

        jQuery('.page-navigation').removeClass('page-navigation--active');
    });

    /* Open sub-navigation */
    jQuery('.sub-menu-toggle').on('click', function() {
       var submenuWrapper1 = jQuery(this).parent().find('.sub-menu__wrapper');

        jQuery(submenuWrapper1).addClass('sub-menu__wrapper--active');
        jQuery('.mobile-toggle__close').addClass('mobile-toggle__close--hide');
        jQuery('.mobile-toggle__back').addClass('mobile-toggle__back--active');
    });

    /* Close navigation */
    jQuery('.mobile-toggle__back').on('click', function(){
        var mobileToggleClose = jQuery(this).parent().find('.mobile-toggle__close');
        var parent = jQuery(this).parent();
        var submenuWrapper = jQuery(parent).parent().find('.sub-menu__wrapper--active');

        jQuery(this).removeClass('mobile-toggle__back--active');
        jQuery(mobileToggleClose).removeClass('mobile-toggle__close--hide');

        jQuery(submenuWrapper).removeClass('sub-menu__wrapper--active');
    });

    /* Fixed scroll-to-top */
    jQuery(window).scroll(function() {
        var scroll = jQuery(window).scrollTop();

        if (scroll >= 500) {
            jQuery(".back-to-top").addClass("back-to-top--active");
        } else {
            jQuery(".back-to-top").removeClass("back-to-top--active");
        }
    });
